import React, { Component } from "react";
import axios from "axios";

import { formatDate, SubmitButton, TextBox } from "../../Components/InputElements";
import PageTitle from "../../Components/PageTitle";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import Select from "react-select";
import { NoRecords } from "../../Components/Shimmer";
import withRouter from "../../Utils/withRouter";
import {currentDateAndTime,getFullYearMonthArray,} from "../../Constants/constants";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { decodeData } from "../../Constants/constants";
class TeamsResignation extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      // employee_leave_id: 0,
      employee_resign_id: 0,
      employee_resign_status:'',
      leave_type_id: 0,
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
      loadingFilter: false,
      month: parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[1]),
      monthOptions: [],
      reportrows: [],
      log_rows: [],
      selectedRows: [],
      checkAll: false,
      mailSubject: '',
      mailBody: ``,
      file:null,
      fileData:null,
      viewResignationDetails:false,
      viewDocument:false,
      notice_period_duration: "",
      last_working_date: "",
      request_last_working_date: "",
      viewResignationLogs: false,
      logRows: [],
      loadingLogs: false,
      decodedData: [],
      department_rows: [],
      location_rows: [],
    };
    this.modalRef = React.createRef();
    this.closeRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
      this.GetDepartmentList();
      this.GetLocationList();
      // this.GetLeaveTypeList();
    });
    let date = currentDateAndTime();
    let monthOpt = getFullYearMonthArray(date);
    this.setState({ monthOptions: monthOpt });
  }
  componentDidUpdate(prevProps, prevState) {
      if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
          const { permissions } = this.context;
          if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
              this.setState({ decodedData });
            }
            console.log("decodedData====>",decodedData)
          } else {
            console.warn("Permissions not yet available. Retrying...");
          }
      }
    }
  GetDepartmentList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Home/GetAllMasters`, { headers })
    .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
            this.setState((prevState) => ({
                department_rows: data.companies__departments.map((row) => ({
                    value: row.department_id,
                    label: row.department_title
                }))
            }));
        }
    });
  }
  GetLocationList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Home/GetAllMasters`, { headers })
        .then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState((prevState) => ({
                    location_rows: data.companies__locations.map((row) => ({
                        value: row.location_id,
                        label: row.location_title
                    }))
                }));
            }
        });
      }
  GetResignLogs = (employee_resign_id, employee_id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}ResignationRouter/GetResignationLog`, {
        params: {
          employee_resign_id: employee_resign_id,
          employee_id: employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        this.setState({ log_rows: [] });
        if (response.data.success === true) {
          this.setState({
            log_rows: data.data,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };

  GetInfo = (row) => {
    let newState = {
      fileName: row?.email_attachments,
      fileSize: "",
      fileDelete:false,
    };

    if (row?.email_attachments && row?.email_attachments.includes("pdf")) {
        newState = {
            ...newState,
            isValidPdfFile: true,
            fileTypeIcon: "/img/pdf-logo.svg",
        };
    } else {
        newState = {
            ...newState,
            // selectedImage: URL.createObjectURL(file),
            fileTypeIcon: "/img/img-logo.png",
        };
    }

    // console.log(newState,
    //   row?.email_body,
    //   row?.email_subject,
    //   row?.document_url,);
    this.setState({
      fileData:newState,
      mailBody: row?.email_body,
      mailSubject: row?.email_subject,
      file:row?.document_url,
      viewResignationDetails:true,
      notice_period_duration: row?.notice_period,
      last_working_date: row?.last_working_date,
      request_last_working_date: row?.request_last_working_date,
    });

  };
  getLogs = (row) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}ResignationRouter/GetResignationLog`, 
        {params: { 
            date: currentDateAndTime(),
            employee_resignation_id: row?.employee_resignation_id,
            employee_id: row?.employee_id,
        },
         headers
        })
        .then((response) => {
            const data = response.data;
            console.info("GetResignationLog",data);
            if (response.data.success === true) {
                this.setState({
                  loadingLogs:false,
                  viewResignationLogs:`${row?.employee_resignation_id}`,
                  logRows: Array.isArray(data.data) && data.data.length>0 ? data.data:[]
                })
            }
            else{
                Swal.fire({
                    title: `<strong>${ response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                });
                this.setState({
                  loadingLogs:false,
                });
            }
            
        })
        .catch(error => {
          this.setState({
            loadingLogs:false,
          });
            Swal.fire({
            title: `<strong>"Failed"</strong>`,
            text: error?.data?.message,
            icon: 'error',
            showConfirmButton: true,
            allowOutsideClick: false
            })
        });
}

  // handleCheckboxChange = (employeeId, employeeLeaveId) => {
  //     this.setState((prevState) => {
  //         const selectedRows = [...prevState.selectedRows];
  //         const index = selectedRows.findIndex(row => row.employee_id === employeeId && row.employee_leave_id === employeeLeaveId);

  //         if (index > -1) {
  //             selectedRows.splice(index, 1);
  //         } else {
  //             selectedRows.push({ employee_id: employeeId, employee_leave_id: employeeLeaveId });
  //         }
  //         console.log(`selectedRows`, selectedRows);
  //         return { selectedRows };
  //     });
  // };

  handleCheckboxChange = (employeeResignId) => {
    this.setState(
      (prevState) => {
        // Copy the previous selectedRows state
        const selectedRows = [...prevState.selectedRows];

        // Find the index of the employeeLeaveId in the selectedRows array
        const index = selectedRows.findIndex((row) => row === employeeResignId);

        // If the id exists, remove it; otherwise, add it
        if (index > -1) {
          selectedRows.splice(index, 1);
        } else {
          selectedRows.push(employeeResignId);
        }

        // Return the updated selectedRows state
        return { selectedRows };
      },
      () => {
        // Callback after setState to access the updated state
        console.log("Updated selectedRows: ", this.state.selectedRows);
      }
    );
  };
  handleSelectAllCheckboxChange = (isChecked) => {
    if (isChecked) {
      this.setState(
        (prevState) => {
          const selectedRows = prevState.rows
            .filter((row) => row.employee_resign_status === 0)
            // .map(row => (row.employee_leave_id));
            .map((row) => row.employee_resign_id);
          return { selectedRows, checkAll: true };
        },
        () => {
          // Callback after setState to access updated state
          console.log("Updated selectedRows: ", this.state.selectedRows);
        }
      );
    } else {
      this.setState({ selectedRows: [], checkAll: false }, () => {
        // Callback after setState to access updated state
        console.log("Updated selectedRows: ", this.state.selectedRows);
      });
    }
  };


  // GetList = () => {
  //     const { apiURL, apiHeaderJSON } = this.context;
  //     const headers = apiHeaderJSON;

  //     axios.get(`${apiURL}ResignationRouter/GetTeamRegistrations`, {
  //         params: {
  //             limit: this.state.limit,
  //             page: this.state.page,
  //             keyword: this.state.keyword,
  //             from_date: this.state.from_date,
  //             to_date: this.state.to_date,
  //             employee_resign_status: this.state.selectOption,
  //             leave_type_id: this.state.filter_leave_type_id,
  //             month: this.state.month,
  //             date: currentDateAndTime(),
  //         },
  //         headers,
  //     })
  //         .then((response) => {

  //             var data = response.data;
  //             if (response.data.success === true) {
  //                 this.setState({
  //                     rows: data.data,
  //                     next: data.next,
  //                     prev: data.prev,
  //                     page: data.page,
  //                     total_records: data.total_records,
  //                     total_pages: data.total_pages,
  //                     loadingList: false,
  //                     loadingFilter:false
  //                 });
  //             }
  //         }).catch((error) => {
  //             console.log(error);
  //             this.setState({
  //                 loadingList: false,
  //                 loadingFilter:false
  //             });
  //             Swal.fire({
  //                 title: `<strong>Failed</strong>`,
  //                 text: 'Opps...! Something went wrong.',
  //                 icon: 'error',
  //                 showConfirmButton: true,
  //                 allowOutsideClick:false,
  //             });

  //         })
  // };

  // LeaveAction = (employee_id, employee_leave_id, accept_reject) => {
  //     Swal.fire({
  //         title: 'Submit Remark',
  //         input: 'text',
  //         inputPlaceholder: 'Enter your Remark',
  //         showCancelButton: true,
  //         confirmButtonText: 'Submit',
  //         cancelButtonText: 'Cancel',
  //         // inputValidator: (value) => {
  //         //     if (!value) {
  //         //         return 'Remark cannot be empty';
  //         //     }
  //         // },
  //     }).then((result) => {
  //         if (result.isConfirmed) {
  //             var formData = {
  //                 employee_resign_status: accept_reject,
  //             };

  //             if (this.state.selectedRows.length !== 0) {
  //                 formData.employee_leave_id = JSON.stringify(this.state.selectedRows);
  //                 formData.type = "bulk";
  //             } else {
  //                 formData.employee_leave_id = employee_leave_id;
  //                 // formData.employee_id = employee_id;
  //             }

  //             if (result.value) {
  //                 formData.remark = result.value;
  //             } else {
  //                 formData.remark = '';
  //             }
  //             const { apiURL, apiHeaderJSON } = this.context;
  //             const headers = apiHeaderJSON;

  //             axios.post(`${apiURL}Approver/LeaveActionSandBox`, formData, { headers })
  //                 .then((response) => {
  //                     Swal.fire({
  //                         title: `<strong>${response.data.message}</strong>`,
  //                         icon: response.data.success === true ? 'success' : 'error',
  //                     });
  //                     this.setState({ selectedRows: [] });
  //                     this.GetList();
  //                 })
  //                 .catch((error) => {
  //                     console.error('Error:', error);
  //                 });
  //         }
  //     });
  // };

  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}ResignationRouter/GetTeamRegistrations`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          employee_resign_status: this.state.selectOption,
          leave_type_id: this.state.filter_leave_type_id,
          department_id: this.state.department_id,
          location_id: this.state.location_id,
          month: this.state.month,
          date: currentDateAndTime(),
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
            loadingFilter: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          loadingList: false,
          loadingFilter: false,
        });
        Swal.fire({
          title: `<strong>Failed</strong>`,
          text: "Opps...! Something went wrong.",
          icon: "error",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      });
  };

  handleSubmit = (row,type) => {
    let swalData={}
    if(type==="2"){
      swalData={
        title: "Submit Remark",
      input: "text",
      inputPlaceholder: "Enter your Remark",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
          if (!value) {
              return 'Remark cannot be empty';
          }
      },
      }
    }
    else{
      swalData={
        title: "Submit Remark",
      input: "text",
      inputPlaceholder: "Enter your Remark",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      }
    }
    Swal.fire({
      ...swalData
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = {
          employee_id: row?.employee_id,
          employee_resignation_id: row?.employee_resignation_id,
          resignation_status: type,
          date: currentDateAndTime(),
        };

        if (result.value) {
          formData.remarks = result.value;
        } else {
          formData.remarks = "";
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        axios
          .post(`${apiURL}ResignationRouter/ResignationAction`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.message}</strong>`,
              icon: response.data.success === true ? "success" : "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
            
            this.GetList();
          })
          .catch((error) => {
            console.error("Error:", error);
            Swal.fire({
              title: `<strong>Opps...! Something went wrong.</strong>`,
              icon: "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
          });
      }
    });
  };
  handleHold = (row) => {
      
    Swal.fire({
      title: "Submit Remark",
      input: "text",
      inputPlaceholder: "Enter your Remark",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value) {
            return 'Remark cannot be empty';
        }
    },
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = {
          employee_id: row?.employee_id,
          employee_resignation_id: row?.employee_resignation_id,
          resignation_status: '4',
          date: currentDateAndTime(),
        };

        if (result.value) {
          formData.remarks = result.value;
        } else {
          formData.remarks = "";
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        axios
          .post(`${apiURL}ResignationRouter/HandleResignationStatus`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
            this.GetList();
          })
          .catch((error) => {
            console.error("Error:", error);
            Swal.fire({
              title: `<strong>"Failed"</strong>`,
              text: error?.data?.message,
              icon: "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
          });
      }
    });
  };
  handleExcelDownload = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    Swal.fire({
      title: "Please wait...",
      html: "Your file is being prepared for download.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    axios
      .get(`${apiURL}Approver/GetPendingLeaves`, {
        params: {
          limit: this.state.total_records,
          page: 1,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          employee_resign_status: this.state.selectOption,
          leave_type_id: this.state.filter_leave_type_id,
        },
        headers,
      })
      .then((response) => {
        if (response.data.success === true) {
          const rows = response.data.data;

          const data = rows.map((row) => ({
            "Resign Date": row.Resign_Date,
            "Employee Code": row.employee_code,
            "Employee Name": row.employee_name,
            Department: row.Department_name,
            location: row.location_name,
            "Resignation Status": row.employee_resign_status,
            // 'Leave Type': row.heads_labels[0].concatenated_data,
            // 'From Date': formatDate(row.employee_leave_from_date),
            // 'To Date': formatDate(row.employee_leave_to_date),
            // 'Duration': row.employee_leave_days + (row.employee_leave_days <= 1 ? " day" : " days"),
            // 'Status': row.employee_leave_status_label,
            // 'Status': row.employee_resign_status,
          }));

          const columns = [
            { header: "Resign Date", key: "Resign Date", width: 30 },
            { header: "Employee Code", key: "Employee Code", width: 30 },
            { header: "Employee Name", key: "Employee Name", width: 30 },
            { header: "Department", key: "Department", width: 30 },
            { header: "Location", key: "Location", width: 30 },
            { header: "Resignation Status", key: "Status", width: 20 },
            // { header: 'Leave Type', key: 'Leave Type', width: 30 },
            // { header: 'From Date', key: 'From Date', width: 20 },
            // { header: 'To Date', key: 'To Date', width: 20 },
            // { header: 'Duration', key: 'Duration', width: 20 },
          ];

          const wb = XLSX.utils.book_new();

          const ws = XLSX.utils.json_to_sheet(data, {
            header: columns.map((column) => column.header),
          });

          ws["!cols"] = columns.map((column) => ({ wch: column.width }));

          XLSX.utils.sheet_add_json(ws, data, {
            skipHeader: true,
            origin: "A2",
          });

          columns.forEach((column, index) => {
            ws[XLSX.utils.encode_cell({ r: 0, c: index })] = {
              v: column.header,
            };
          });

          XLSX.utils.book_append_sheet(wb, ws, "AbStart Leave Report");

          XLSX.writeFile(wb, "AbStartLeaveReport.xlsx");

          Swal.close();

          Swal.fire({
            title: "<strong>Success</strong>",
            html: "Your file has been downloaded successfully.",
            icon: "success",
          });
        } else {
          Swal.close();

          Swal.fire({
            title: "<strong>Error</strong>",
            html: response.data.message,
            icon: "error",
          });
        }
      })
      .catch((error) => {
        // Close the Swal alert if there is an error
        Swal.close();

        Swal.fire({
          title: "<strong>Error</strong>",
          html: error.message,
          icon: "error",
        });
      });
  };

  resetForm = () => {
    this.setState({
      employee_resign_id: 0,
      leave_type_id: "",
      employee_id: "",
      employee_leave_from_date: "",
      employee_leave_to_date: "",
      employee_leave_document: "",
      employee_leave_reason: "",
      employee_leave_to_day_unit: "",
      employee_leave_from_day_unit: "",
      fileName: "",
      fileSize: "",
    });
  };

  resetemployee_leave_document = () => {
    // Clear the input value
    const employee_leave_document = document.getElementById(
      "employee_leave_document"
    );
    if (employee_leave_document) {
      employee_leave_document.value = null;
    }
    // Keep the same key for the input
    let randomString = Math.random().toString(36);
    this.setState({
      theInputKey: randomString,
    });
  };

  handleInputSearch = (e) => {
    this.GetList();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
      }
    );
  };

  handleSelectStatus = (selectedOption) => {
    this.setState({ selectOption: selectedOption.value });
  };

  handleSelectType = (selectedOption) => {
    this.setState({ filter_leave_type_id: selectedOption.value });
  };

  handleClearAll = () => {
    this.setState(
      {
        filter_leave_type_id: "",
        // rows: [],
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
        keyword: "",
        from_date: "",
        to_date: "",
        selectOption: "",
        month: new Date()?.getMonth(),
      },
      () => {
        this.GetList();
      }
    );
  };

  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1,
      },
      () => {
        this.GetList();
      }
    );
  };

  render() {
    const { reportrows, log_rows } = this.state;
    const limitOptions = [10, 25, 50, 100, 200, 500, this.state.total_records];
    const options = [
      // { value: "0", label: "Pending" },
      { value: "0", label: "Applied" },
      { value: "1", label: "Approved" },
      { value: "2", label: "Rejected" },
      { value: "3", label: "Cancelled" },
      { value: "4", label: "On Hold" },
    ];

    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "#007bff" : "#fff",
        color: state.isSelected ? "#fff" : "#333",
        // padding: 10,
        ":hover": {
          backgroundColor: "#007bff",
          color: "#FFF",
        },
      }),
    };

    return this.state.loadingList === false ? (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle
              title={`Team Resignation`}
              primary={`Team Employees`}
              path={`/TeamEmployees`}
            />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-3">
                        <label htmlFor="keyword">Employee Name</label>
                        <div className="input-group">
                          <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search Name"/>
                          <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2">
                            <i className="ri-search-line"></i>
                          </button>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange}/>
                      </div>
                      <div className="col-md-3">
                        <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange}/>
                      </div>
                      {/* <div className='col-md-2 '>
                          <div className='position-relative'>
                              <div>
                                  <label>Month</label>
                              </div>
                              <div style={{ "zIndex": 10, "width": "100%" }} className=' position-absolute'>
                                  <Select
                                      options={this.state.monthOptions}
                                      value={this.state.month ? this.state.monthOptions.find(option => option.value === this.state.month) : null}
                                      onChange={(selectOption) => this.setState({ month: selectOption?.value })}
                                      hint={`Select Month`}
                                  />
                              </div>
                          </div>
                      </div> */}
                      <div className="col-md-3 position-relative mb-5">
                        <div className="position-relative">
                          <div><label>Status</label></div>
                          <div style={{ zIndex: 10, width: "100%" }} className=" position-absolute">
                            <Select onChange={this.handleSelectStatus}
                            options={options}
                            placeholder={`Select Status`}
                            value={ this.state.selectOption ? options.find( (option) => option.value === this.state.selectOption ) : null }
                            styles={customStyles}/>
                          </div>
                        </div>
                      </div>
                      {/* <div className='col-md-3'>
                          <div className='position-relative'>
                              <div>
                                  <label>Leave Type</label>
                              </div>
                              <div style={{ "zIndex": 10, "width": "100%" }} className=' position-absolute'>
                                  <Select onChange={this.handleSelectType}
                                      placeholder={`Select Leave Type`}
                                      options={this.state.leave_type_rows}
                                      value={this.state.filter_leave_type_id ? this.state.leave_type_rows.find((option) => option.value === this.state.filter_leave_type_id) : null} // Add this line
                                  />

                              </div>
                          </div>
                      </div> */}
                      {/* <div className='col-md-6'>
                        <div className="row"> */}
                      <div className="col-md-3 position-relative mb-5">
                        <div><label>Location</label></div>
                        <div style={{ zIndex: 9, width: "90%" }} className=" position-absolute">
                          <Select onChange={(selectedOption) => this.handleSelectChange( "location_id", selectedOption ) }
                            options={this.state.location_rows}
                            placeholder={`All`}
                            value={ this.state.location_id ? this.state.location_rows.find( (option) => option.value === this.state.location_id ) : null }/>
                        </div>
                      </div>
                      <div className="col-md-3 position-relative mb-5">
                        <div><label>Department</label></div>
                        <div style={{ zIndex:8, width: "90%" }} className=" position-absolute">
                          <Select onChange={(selectedOption) => this.handleSelectChange( "department_id", selectedOption ) }
                            options={this.state.department_rows}
                            placeholder={`All`}
                            value={ this.state.department_id ? this.state.department_rows.find( (option) => option.value === this.state.department_id ) : null }/>
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-3 col-6 ">
                        <div>
                          <label>Apply Filter</label>
                        </div>
                        {/* {this.state.loadingFilter === "1" ? (
                          <button className="btn btn-info btn-load">
                            <span className="d-flex align-items-center">
                              <span
                                className="spinner-border flex-shrink-0"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </span>
                              <span className="flex-grow-1 ms-2">
                                Loading...
                              </span>
                            </span>
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={() => {
                              this.setState(
                                {
                                  loadingFilter: "1",
                                },
                                () => {
                                  this.handleInputSearch();
                                  console.log(
                                    "this.state.loadingFilter1 ==>",
                                    this.state.loadingFilter
                                  );
                                }
                              );

                            }}
                            className={`w-100 btn btn-info btn-label waves-effect waves-light ${
                              !this.state.keyword &&
                              !this.state.from_date &&
                              !this.state.to_date &&
                              !this.state.selectOption &&
                              !this.state.department_id &&
                              !this.state.location_id
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                            Filter
                          </button>
                        )} */}
                        <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "1"},()=>{this.handleInputSearch()})}} 
                        disabled={!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption && !this.state.department_id && !this.state.location_id}
                        loading={this.state.loadingFilter==="1"} loadingMessage='Loading' 
                        buttonName={"Filter"}  type='info' icon='ri-filter-3-fill' />
                      </div>
                      <div className="col-lg-2 col-md-3 col-6 ">
                        <div><label>Clear Filter</label></div>
                        {/* {this.state.loadingFilter === "2" ? (
                          <button className="btn btn-secondary btn-load">
                            <span className="d-flex align-items-center">
                              <span
                                className="spinner-border flex-shrink-0"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </span>
                              <span className="flex-grow-1 ms-2">
                                Loading...
                              </span>
                            </span>
                          </button>
                        ) : (
                          <button
                            type="button"
                            className={`btn w-100 noWrap btn-secondary btn-label waves-effect waves-light ${
                              !this.state.keyword &&
                              !this.state.from_date &&
                              !this.state.to_date &&
                              !this.state.selectOption &&
                              !this.state.department_id &&
                              !this.state.location_id
                                ? "disabled"
                                : ""
                            }`}
                            onClick={() => {
                              this.setState({ loadingFilter: "2" }, () => {
                                this.handleClearAll();
                                console.log(
                                  "this.state.loadingFilter1 ==>",
                                  this.state.loadingFilter
                                );
                              });
                            }}
                          >
                            <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 noWrap"></i>{" "}
                            Clear
                          </button>
                        )} */}
                        <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "2"},()=>{this.handleClearAll()})}} 
                        disabled={!this.state.from_date && !this.state.to_date}
                        loading={this.state.loadingFilter==="2"} loadingMessage='Loading' 
                        buttonName={"Clear"}  type='secondary' icon='ri-database-2-line' />
                      </div>
                      {/* <div style={{ width: "14%" }} className="col-md-3 mt-3">
                        <div>
                          <label>Export Excel</label>
                        </div>
                        <button
                          type="button"
                          onClick={this.handleExcelDownload}
                          className={`${
                            this.state.rows.length === 0 ? "disabled" : ""
                          } btn btn-success btn-label waves-effect waves-light noWrap`}
                        >
                          <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                          Export Excel
                        </button>
                      </div> */}
                    </div>
                      {/* </div>
                    </div> */}
                    {/* <div className='col-md-3'>
                      <div className="row">
                          <div className='col-md-12'>
                              <div>
                                  <label>Export Excel</label>
                              </div>
                              <button
                                  type="button"
                                  onClick={this.handleExcelDownload}
                                  className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-info btn-label waves-effect waves-light`}>
                                  <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                  Export Excel
                              </button>
                          </div>
                      </div>
                    </div> */}
                  </div>
                  {/* className={`table table-bordered table-hover`} */}
                  <div className="card-body">
                    <div className="card mt-3">
                      <div style={{ maxHeight: "65vh", overflowY: "auto", overflowX: "auto", }} className="table-responsive-lg" >
                        <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped" >
                          <thead className="bg-primary text-light bg-gradient position-sticky top-0 z-1">
                            <tr className="text-center">
                              {/* <th className=' noWrap'>Select
                                  <div className="d-flex justify-content-center align-items-center">
                                      <input
                                          type="checkbox"
                                          className={` form-check-input`}
                                          checked={this.state.selectedRows?.length >= 1 && this.state.checkAll}
                                          onChange={(e) => this.handleSelectAllCheckboxChange(e.target.checked)}
                                          disabled={this.state?.rows?.length < 1}
                                      />
                                  </div>
                              </th> */}
                              <th className=" noWrap">Resign Date</th>
                              <th className=" noWrap">Employee Code</th>
                              <th className=" noWrap">Employee Name</th>
                              <th className=" noWrap">Department</th>
                              <th className=" noWrap">Location</th>
                              <th className=" noWrap">Status </th>
                              {(this.state.decodedData?.includes(1) || this.state.decodedData?.includes(5))  &&(
                              <th width="100" className="text-center">
                                Details
                              </th>)}
                              {this.state.decodedData?.includes(3) &&(
                              <th width="100" className="text-center">
                                Action
                              </th>)}
                              {/* <th className=' noWrap'>Leave Type</th> */}
                              {/* <th className=' noWrap'>From Date</th>
                                                                <th className=' noWrap'>To Date</th> */}
                              {/* <th className=' noWrap'>Leaves Days</th> */}
                              {/* <th className=' noWrap'>Leaves Status </th>
                                                                <th className=' noWrap'>Leaves Details </th> */}
                              {/* <th className=' noWrap'>Resignation Status </th> */}
                              {/* <th className=' noWrap'>Resignation Details </th> */}

                              {/* <th width="100" className="text-center">Resignation Details</th> */}
                              {/* <th width="100" className="text-center">Action</th> */}
                            </tr>
                          </thead>

                          {this.state.rows.length === 0 ? (
                            <tbody>
                              <tr>
                                <td colSpan={11}>
                                  <NoRecords />
                                </td>
                              </tr>
                            </tbody>
                          ) : (
                            <tbody>
                              {this.state.rows.map((row) => {
                                return (
                                  <tr key={row.employee_resign_id}>
                                    {/* <td >
                                        <div className="d-flex justify-content-center align-items-center">
                                            <input
                                                type="checkbox"
                                                className={`${row.employee_leave_status === 0 ? "" : `disabled bg-${row?.employee_leave_status_class}`} form-check-input`}
                                                checked={this.state.selectedRows.some(selectedRow => selectedRow === row.employee_leave_id)}
                                                onChange={() => row.employee_leave_status === 0 && this.handleCheckboxChange(row.employee_leave_id)}
                                                disabled={row.employee_leave_status !== 0}
                                            />
                                        </div>
                                    </td> */}
                                    <td className=" noWrap">{ row.resignation_date? formatDate(row.resignation_date):"--"} </td>
                                    <td className=" noWrap">{row.employee_code}</td>
                                    <td> {row.employee_name}</td>
                                    <td> {row.department_title}</td>
                                    <td> {row.location_title}</td>
                                    <td className='text-center'><span className={`badge bg-${row.ResignationStatusClasses}`} >{row.ResignationStatus}</span></td>
                                    
                                   
                                    

                                    {/* <td className=' noWrap'>{row.heads_labels[0].concatenated_data}</td> */}
                                    {/* <td className=' noWrap'>{formatDate(row.employee_leave_from_date)}</td>
                                                                            <td className=' noWrap'>{formatDate(row.employee_leave_to_date)}</td> */}
                                    {/* <td>{row.employee_leave_days} <span>Days</span></td> */}
                                    {/* <td className='text-center'><span className={`badge bg-${row.employee_resign_status_class}`} >{row.employee_resign_status}</span></td> */}
                                    {(this.state.decodedData?.includes(1) || this.state.decodedData?.includes(5)) && (
                                      <td>
                                        <div className="d-flex align-items-center gap-2">
                                          
                                          {/* View Button - Only for decodedData includes 1 */}
                                          {this.state.decodedData?.includes(1) && (
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-primary"
                                              onClick={() => this.GetInfo(row)}
                                            >
                                              View
                                            </button>
                                          )}

                                          {/* Logs Button - Conditional Rendering Based on loadingLogs */}
                                          {this.state.decodedData?.includes(5) &&
                                            (this.state.loadingLogs === row?.employee_resignation_id ? (
                                                          <button className="btn btn-sm btn-info btn-load">
                                                            <span className="d-flex align-items-center">
                                                              <span
                                                                className="spinner-border flex-shrink-0"
                                                                role="status"
                                                                style={{
                                                                  width: "0.8rem",
                                                                  height: "0.8rem",
                                                                  borderWidth: "2px",
                                                                }}
                                                              >
                                                                <span className="visually-hidden">Loading...</span>
                                                              </span>
                                                            </span>
                                                          </button>
                                                        ) : (
                                                          (this.state.decodedData?.includes(5) && 
                                                          <button
                                                            type="button"
                                                            className="btn btn-sm btn-info"
                                                            onClick={() => {
                                                              if (!this.state.loadingLogs) {
                                                                this.setState(
                                                                  {
                                                                    loadingLogs: `${row?.employee_resignation_id}`,
                                                                  },
                                                                  () => this.getLogs(row)
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            Logs
                                                          </button>)

                                            ))
                                          }
                                        </div>
                                      </td>
                                    )}

                                    { this.state.decodedData?.includes(3) && ( 
                                    <td>
                                      <div className="d-flex justify-content-around gap-2">
                                      { this.state.decodedData?.includes(3) && ( 
                                        <button
                                          onClick={() =>
                                            this.handleSubmit(row,"1")
                                          }
                                          type="button"
                                          className={`${
                                            row.show_approve_button? ""
                                              : "disabled"
                                          }  btn btn-success btn-sm`}
                                        >
                                          {/* <i className="bx bx-check-circle label-icon align-middle fs-20 "></i> */}
                                          Approve
                                        </button>)}
                                        { this.state.decodedData?.includes(3) && ( 

                                        <button
                                          onClick={() =>
                                            this.handleHold(row)
                                          }
                                          type="button"
                                          className={`${
                                            row.show_hold_button
                                              ? ""
                                              : "disabled"
                                          }  btn btn-warning btn-sm`}
                                        >
                                          Hold
                                        </button>
                                        )}
                                        { this.state.decodedData?.includes(3) && ( 
                                        <button
                                          onClick={() =>
                                            this.handleSubmit(
                                              row,
                                              "2"
                                            )
                                          }
                                          type="button"
                                          className={`${
                                            row.show_reject_button
                                              ? ""
                                              : "disabled"
                                          }  btn btn-danger btn-sm`}
                                        >
                                          {/* <span
                                              class="spinner-border flex-shrink-0"
                                              role="status"
                                              style={{
                                              width: "0.8rem",
                                              height: "0.8rem",
                                              borderWidth: "2px",
                                              }}
                                          >
                                              <span class="visually-hidden">Loading...</span>
                                          </span> */}
                                          {/* <i className="bx bx-x-circle label-icon align-middle fs-20 "></i> */}
                                          Reject
                                        </button>)}
                                      </div>
                                    </td>
                                    )}
                                  </tr>
                                );
                              })}
                            </tbody>
                          )}
                        </table>
                      </div>
                      <div className="d-flex justify-content-between bg-light align-items-center flex-wrap w-100 py-2 px-2" >
                        {/* <button disabled={ this.state.prev === false && this.state.loadingList === false ? true : false }
                        type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}>
                          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                          Previous
                        </button> */}
                        <SubmitButton onClick={()=>{ this.handlePrev() }} 
                        disabled={this.state.prev === false && this.state.loadingList === false}
                        buttonName={"Previous"}  type='warning' icon='ri-arrow-left-line' />
                        <SubmitButton otherClasses='d-md-none d-block' iconSide='right' onClick={()=>{ this.handleNext() }} 
                        disabled={this.state.next === false && this.state.loadingList === false}
                        buttonName={"Next"}  type='primary' icon='ri-arrow-right-line' />
                        <div className="col-md-4 col-12 my-md-0 my-2" style={{ display: "flex", alignItems: "center" }}>
                          {
                            <small>
                              Total Records: {this.state.total_records} | Total
                              Pages: {this.state.total_pages} | Current Page:{" "}
                              {this.state.page}
                            </small>
                          }
                        </div>
                        <div className="col-md-2">
                          <select className="form-select" onChange={(e) => this.handleChange(e)}>
                            {Array.from(
                              { length: this.state.total_pages },
                              (_, i) => (
                                <option selected={this.state.page === i + 1} key={i} value={i + 1}>
                                  Page {i + 1}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                        <div className="col-md-2">
                          <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                            {limitOptions.map((option) => (
                              <option key={option} value={option}>
                                Limit {option}
                              </option>
                            ))}
                          </select>
                        </div>
                        {/* <button disabled={ this.state.next === false && this.state.loadingList === false ? true : false }
                          type="button"
                          onClick={() => this.handleNext()}
                          className={`btn btn-primary btn-label waves-effect right waves-light`}
                        >
                          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                          Next
                        </button> */}
                        <SubmitButton otherClasses='d-md-block d-none' iconSide='right' onClick={()=>{ this.handleNext() }} 
                        disabled={this.state.next === false && this.state.loadingList === false}
                        buttonName={"Next"}  type='primary' icon='ri-arrow-right-line' />
                      </div>
                    </div>
                    <div className="modal fade" id="exampleModalPopovers" tabIndex={-1} aria-labelledby="exampleModalPopoversLabel" aria-modal="true">
                      <div className="m-auto mt-3 w-modal">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalPopoversLabel">Employee Leave Details</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
                          </div>
                          <div className="modal-body">
                            <div class="card shadow-none">
                              <div class="card-header d-flex justify-content-between align-items-center">
                                <h6 class="card-title mb-0">
                                  {reportrows.employee_name}
                                </h6>
                                {reportrows.leave_type_name && (
                                  <h6 class="card-title mb-0">
                                    {reportrows.leave_type_name}
                                  </h6>
                                )}
                                <a
                                  href={`${reportrows.employee_leave_document_url}`}
                                  className={`${
                                    !reportrows.employee_leave_document_url
                                      ? "d-none"
                                      : ""
                                  } link-info link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover`}
                                  style={{ marginTop: "10px", float: "right" }}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View Uploaded Document
                                </a>
                              </div>
                              <div class="card-body">
                                <div className="d-flex justify-content-between align-items-center flex-wrap">
                                  <h6 class="">
                                    From :
                                    {formatDate(
                                      reportrows.employee_leave_from_date
                                    )}
                                    <div>
                                      <span className="text-muted mt-2">
                                        {
                                          reportrows.employee_leave_from_day_unit
                                        }
                                      </span>
                                    </div>
                                  </h6>
                                  <h6 class="">
                                    To :
                                    {formatDate(
                                      reportrows.employee_leave_to_date
                                    )}
                                    <div>
                                      <span className="text-muted mt-2">
                                        {reportrows.employee_leave_to_day_unit}
                                      </span>
                                    </div>
                                  </h6>
                                  <h6 class="">
                                    Total Leave days :
                                    {reportrows.employee_leave_days}
                                  </h6>
                                </div>
                              </div>
                              <div class="card-footer d-flex justify-content-between align-items-center flex-wrap">
                                <div className="">
                                  <span class="">Leave Reason</span>
                                  <p class="card-text text-muted mb-0">
                                    {reportrows.employee_leave_reason ||
                                      "No Reason"}
                                  </p>
                                </div>
                                <span
                                  className={`badge bg-${reportrows.employee_resign_status_class}`}
                                >
                                  {reportrows.employee_resign_status}
                                </span>
                              </div>
                            </div>

                            <div className="my-3">
                              <h5
                                className="modal-title"
                                id="exampleModalPopoversLabel"
                              >
                                Employee Resignation Logs
                              </h5>
                            </div>
                            <table className="table table-nowrap text-center mb-0">
                              <thead className="table-light">
                                <tr>
                                  <th>Action Date</th>
                                  <th>Action By</th>
                                  {/* <th>Leave Type</th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th>Total Leave Days</th> */}
                                  {/* <th>Reason</th> */}
                                  <th>Remark</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {log_rows.map((row) => {
                                  var leave_obj = JSON.parse(
                                    row.leave_apply_object
                                  );
                                  return (
                                    <tr key={row.employee_leave_log_id}>
                                      <td>{formatDate(row.created_date)}</td>
                                      <td>{row.created_by_name}</td>
                                      <td>{leave_obj.leave_name}</td>
                                      <td>{formatDate(leave_obj.employee_leave_from_date)}
                                      </td>
                                      <td>
                                        {formatDate( leave_obj.employee_leave_to_date )}
                                      </td>
                                      <td>{leave_obj.employee_leave_days}</td>
                                      <td>{leave_obj.employee_leave_reason}</td>
                                      <td>{row.remark}</td>
                                      <td><span className={`badge bg-${row.employee_resign_log_status_class}`}>{row.employee_resign_status} </span>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-light"
                              data-bs-dismiss="modal"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.state.viewResignationDetails && (
                    <div id="myModal" className="modal show" tabIndex={-1} style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }} aria-labelledby="myModalLabel" aria-hidden="true">
                      <div
                        className="m-auto mt-3 w-modal">
                        <div className="modal-content">
                          <div className='card'>
                            <div className='card-header align-items-center d-flex'>
                                <h4 className='card-title mb-0 flex-grow-1'>
                                    {/* {company_salary_head_id ? "Update Payroll Head" : "Create Payroll Head"} */}
                                    {'Resignation Mail'}
                                </h4>
                                <div className=' d-flex align-items-center gap-2'>
                                    <button onClick={() => { this.setState({ viewResignationDetails:false, mailSubject: '', mailBody: ``, file:null, fileData:null, notice_period_duration:"", last_working_date:"", request_last_working_date:"", }); }}
                                    className="btn-close" aria-label="Close"/>
                                    {/* <NavLink className='btn btn-success btn-sm py-2' to={`/EmailTemplateList`}>
                                        <i className='bx bx-list-ul label-icon align-middle fs-4 ' />
                                    </NavLink> */}
                                </div>
                            </div>
                            <div className='card-body'>
                                <form >
                                    <div className='row gy-4'>
                                        <div className='col-md-6 mb-3 mt-3'>
                                            <label htmlFor='mailSubject' className='form-label'>Subject:</label>
                                            <input type='text' id='mailSubject' name='mailSubject' disabled value={this.state?.mailSubject} className={`form-control`}/>
                                        </div>
                                        <div className='col-md-3 mb-3 mt-3'>
                                          <label htmlFor='notice_period_duration' className='form-label'>
                                            Notice Period:
                                          </label>
                                          <input
                                          type='text'
                                          id='notice_period_duration'
                                          name='notice_period_duration'
                                          disabled
                                          value={`${this.state.notice_period_duration || 0} Days`}
                                          // onChange={e =>
                                          //     handleInputChange('notice_period_duration', e.target.value)
                                          // }
                                          className={`form-control`}
                                          placeholder=''
                                          />
                                      </div>
                                      <div className='col-md-3 mb-3 mt-3'>
                                          <label htmlFor='relieving_date' className='form-label'>
                                          Official Relieving Date:
                                          </label>
                                          <input
                                          type='text'
                                          id='relieving_date'
                                          name='relieving_date'
                                          disabled
                                          value={ this.state.last_working_date && this.state.last_working_date!="0"? formatDate(this.state.last_working_date): "None"}
                                          // onChange={e =>
                                          //     handleInputChange('relieving_date', e.target.value)
                                          // }
                                          className={`form-control`}
                                          placeholder=''
                                          />
                                      </div>
                                        <div className='col-md-6 mb-3 mt-3'>             
                                            <label className="form-label">Attachment<small className='text-muted '>{this.state.file?'':" (Not Uploaded!)"}</small></label>
                                            <div>
                                                <ul
                                                    className="list-unstyled mb-0"
                                                    id="dropzone-preview"
                                                    style={{ display: this.state.file ? "block" : "none", }}>
                                                    <li className="mt-2 dz-processing dz-error dz-complete"
                                                        id="dropzone-preview-list">
                                                        <div className="border rounded">
                                                            <div className="d-flex p-2">
                                                                <div onClick={()=>{
                                                                    if(!this.state.fileData?.fileDelete && this.state?.file){
                                                                        this.setState({ viewDocument:true })
                                                                    }
                                                                  }} 
                                                                className={`cursorPointer flex-shrink-0 me-3`}>
                                                                    <div className="avatar-sm bg-light rounded d-flex align-items-center justify-content-center">
                                                                        {/* <i className={formData.fileData?.fileTypeIcon} style={{ position: "absolute", color: "green", marginLeft: "12px", marginTop: "5px", fontSize: "25px" }}></i> */}
                                                                        <img style={{ width:"20px"}} src={this.state.fileData?.fileTypeIcon} alt="pdf" />
                                                                    </div>
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <div className="pt-1">
                                                                        <h5
                                                                            className="fs-13 mb-1"
                                                                            data-dz-name=""
                                                                        >
                                                                            {this.state.fileData?.fileName}
                                                                        </h5>
                                                                        <p
                                                                            className="fs-13 text-muted mb-0"
                                                                            data-dz-size=""
                                                                        >
                                                                            {/* <strong>{formData.fileData?.fileSize}</strong> */}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                      
                                        </div>
                                        <div className='col-md-6 mb-3 mt-3'>
                                            <label htmlFor='relieving_date' className='form-label'>
                                                Requested Relieving Date:
                                            </label>
                                            <input
                                                type='text'
                                                id='relieving_date'
                                                name='relieving_date'
                                                disabled
                                                value={ this.state.request_last_working_date && this.state.request_last_working_date!="0"? formatDate(this.state.request_last_working_date): "None"}
                                                // onChange={e =>
                                                //     handleInputChange('relieving_date', e.target.value)
                                                // }
                                                className={`form-control`}
                                                placeholder=''
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <div className=' card-body border-1 rounded-3 bg-light'
                                        dangerouslySetInnerHTML={{ __html: this.state?.mailBody? this.state?.mailBody: "", }}/>
                                    </div>
                                </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.viewDocument && (
                    <div id="myModal" className="modal show" tabIndex={-1} style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }} aria-labelledby="myModalLabel" aria-hidden="true">
                      <div className=" bg-light m-auto mt-3">
                        <div className="modal-content">
                          <div className="modal-header pb-0">
                            <h5 className="modal-title" id="myModalLabel">Document</h5>
                            <button onClick={() => { this.setState({ viewDocument: false, }); }} className="btn-close" aria-label="Close"></button>
                          </div>
                          <div className="modal-body pt-0">
                            <div>
                              <div className="mb-4 m-auto p-1 rounded-2 grayBlurShadow">
                                <h6 className="text-center text-ellipse">{this.state.fileData.fileName || ''}</h6>
                                <div
                                  className="m-auto rounded-3 overflow-hidden"
                                  style={{
                                    width: this.state.file && this.state.file?.includes("pdf")?"100%":"60%",
                                    height: this.state.file && this.state.file?.includes("pdf")?"600px":"auto",
                                    border: "1px solid #ccc",
                                  }}
                                >
                                  {this.state.file && this.state.file?.includes("pdf") ? (
                                    <iframe
                                      src={this.state.file}
                                      title="PDF Viewer"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                      }}
                                      frameBorder="0"
                                    >
                                      This browser does not support embedded
                                      files.
                                    </iframe>
                                  ) : (
                                    <img
                                      src={this.state.file}
                                      style={{
                                        width: "100%",
                                        // height: "100%",
                                      }}
                                      alt="document_image"
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <div className="modal-footer">
                            <button
                              onClick={() => {
                                this.setState({
                                  viewDocument: false,
                                  doc_title: "",
                                  doc_url: "",
                                });
                              }}
                              className="btn btn-light"
                            >
                              Close
                            </button>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.viewResignationLogs && (
                      <div className="modal show"  style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}  >
                      <div className="m-auto mt-3 w-modal">
                          <div className="modal-content">
                          <div className="modal-header pb-0">
                              <h5 className="modal-title" id="rmModalLabel">Resignation Logs</h5>
                              <button type="button" className="btn-close" onClick={()=> {
                                this.setState({
                                  viewResignationLogs:false
                                })
                              }} aria-label="Close" />
                          </div>
                          <div className="modal-body pt-0">
                          {/* <div className='row gy-4'> */}
                            <h6>Employee: {Array.isArray(this.state.logRows) && this.state.logRows.length > 0 ? this.state.logRows[0]?.employee_name: "--"}</h6>
                            <h6>Subject: {Array.isArray(this.state.logRows) && this.state.logRows.length > 0 ? this.state.logRows[0]?.email_subject: "--"}</h6>
                          {/* </div> */}
                              {/* <div className='row gy-4'>
                                  <div className='col-md-6 mb-3 '>
                                      <label htmlFor='mailSubject' className='form-label'>
                                      Subject:
                                      </label>
                                      <input
                                      type='text'
                                      id='mailSubject'
                                      name='mailSubject'
                                      disabled
                                      value={this.state?.mailSubject}
                                      // onChange={e =>
                                      //     handleInputChange('mailSubject', e.target.value)
                                      // }
                                      className={`form-control`}
                                      placeholder='Enter Subject'
                                      />
                                  </div>
                                  <div className='col-md-6 mb-3 '>
                                      <label htmlFor='notice_period_duration' className='form-label'>
                                      Notice Period:
                                      </label>
                                      <input
                                      type='text'
                                      id='notice_period_duration'
                                      name='notice_period_duration'
                                      disabled
                                      value={`${this.state?.notice_period_duration || 0} Days`}
                                      // onChange={e =>
                                      //     handleInputChange('notice_period_duration', e.target.value)
                                      // }
                                      className={`form-control`}
                                      placeholder=''
                                      />
                                  </div>
                                  <div className='col-md-6 mb-3 mt-0'>
                                      <label htmlFor='relieving_date' className='form-label'>
                                      Official Relieving Date:
                                      </label>
                                      <input
                                      type='text'
                                      id='relieving_date'
                                      name='relieving_date'
                                      disabled
                                      value={ this.state?.last_working_date && this.state?.last_working_date!="0" ? formatDate(this.state?.last_working_date): "None"}
                                      // onChange={e =>
                                      //     handleInputChange('relieving_date', e.target.value)
                                      // }
                                      className={`form-control`}
                                      placeholder=''
                                      />
                                  </div>
                                  <div className='col-md-6 mb-3 mt-0'>
                                      <label htmlFor='relieving_date' className='form-label'>
                                          Requested Relieving Date:
                                      </label>
                                      <input
                                          type='text'
                                          id='relieving_date'
                                          name='relieving_date'
                                          disabled
                                          value={ this.state.requestedRelievingDate && this.state.requestedRelievingDate!="0"? formatDate(this.state.requestedRelievingDate): "None"}
                                          // onChange={e =>
                                          //     handleInputChange('relieving_date', e.target.value)
                                          // }
                                          className={`form-control`}
                                          placeholder=''
                                      />
                                  </div>
                              </div> */}
                              <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                  <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                      <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                          <tr>
                                              <th style={{ width:"5%"}} className="text-center">Sr.No.</th>
                                              <th style={{ width:"8%"}} className="text-center noWrap">Resignation Date</th>
                                              {/* <th className="text-center">Subject</th> */}
                                              <th style={{ width:"10%"}} className="text-center">Status</th>
                                              <th className="noWrap">Employee Remarks</th>
                                              <th className="noWrap">RM Remarks</th>
                                          </tr>
                                      </thead>
                                      {Array.isArray(this.state.logRows) && this.state.logRows.length === 0 ? (
                                          <tbody>
                                          <tr>
                                              <td colSpan={11}>
                                              <NoRecords />
                                              </td>
                                          </tr>
                                          </tbody>
                                      ) :
                                          <tbody>
                                          {Array.isArray(this.state.logRows) && this.state.logRows.map((row,idx) => {
                                              return (
                                              <tr key={row.employee_id}>
                                                  <td className="text-center">{idx+1}</td>
                                                  <td className="noWrap text-center">{row.resignation_date? formatDate(row.resignation_date):"--"}</td>
                                                  {/* <td>{row.goal_title}</td> */}
                                                  <td>
                                                      <div
                                                          style={{ fontSize: "0.65rem" }}
                                                          className={`noWrap bg-${row?.ResignationStatusClasses} text-white fw-semibold px-1 text-center py-1  rounded-4`}
                                                      >
                                                          {row?.ResignationStatus}
                                                      </div>
                                                  </td>
                                                  <td className={`${row?.employee_remarks? "":"text-center"}`} >{row?.employee_remarks || "--"}</td>
                                                  <td className={`${row?.rm_remarks? "":"text-center"}`} >{row?.rm_remarks || "--"}</td>
                                              </tr>
                                              );
                                          })}
                                          </tbody>}
                                          {/* <tfoot className="table-light">
                                              <tr>
                                              <th colSpan={8}>
                                                  <div className="d-flex justify-content-between">
                                                  <button
                                                      disabled={
                                                      prev === false &&
                                                          loadingList === false
                                                          ? true
                                                          : false
                                                      }
                                                      type="button"
                                                      onClick={() => this.handlePrev()}
                                                      className={`btn btn-warning btn-label waves-effect waves-light`}
                                                  >
                                                      <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                      Previous
                                                  </button>
                                                  <div
                                                      className="col-md-4"
                                                      style={{ display: "flex", alignItems: "center" }}
                                                  >
                                                      {
                                                      <small>
                                                          Total Records: {total_records} |
                                                          Total Pages: {total_pages} |
                                                          Current Page: {page}
                                                      </small>
                                                      }
                                                  </div>
                                                  <div className="col-md-2">
                                                      <select
                                                      className="form-select"
                                                      onChange={(e) => this.handleChange(e)}
                                                      >
                                                      {Array.from(
                                                          { length: total_pages },
                                                          (_, i) => (
                                                          <option
                                                              selected={page === i + 1}
                                                              key={i}
                                                              value={i + 1}
                                                          >
                                                              Page {i + 1}
                                                          </option>
                                                          )
                                                      )}
                                                      </select>
                                                  </div>
                                                  <div className="col-md-2">
                                                      <select
                                                      className="form-select"
                                                      onChange={this.handleLimitChange}
                                                      value={limit}
                                                      >
                                                      {limitOptions.map((option) => (
                                                          <option key={option} value={option}>
                                                          Limit {option}
                                                          </option>
                                                      ))}
                                                      </select>
                                                  </div>
                                                  <button
                                                      disabled={
                                                      next === false &&
                                                          loadingList === false
                                                          ? true
                                                          : false
                                                      }
                                                      type="button"
                                                      onClick={() => this.handleNext()}
                                                      className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                  >
                                                      <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                      Next
                                                  </button>
                                                  </div>
                                              </th>
                                              </tr>
                                          </tfoot> */}
                                  </table>
                              </div>
                          </div>
                          </div>
                      </div>
                      </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "90vh" }}
      >
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(TeamsResignation);
